import {connect} from 'react-redux';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {PopoverTransferProps} from '../../../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {CompanyModel} from '../../../../models/api/companyModel';
import {InboxModel} from '../../../../models/api/inboxModel';
import {RefinementOptionModel} from '../../../../models/api/refinementOptionModel';
import {TagModel} from '../../../../models/api/tagModel';
import {TeammateModel} from '../../../../models/api/teammateModel';
import {AppState} from '../../../../store/appState';
import {getLenses} from '../../../../store/data/lenses/lensesSelectors';
import {
  makeGetLensCriteria,
  makeGetLensUpdatedAt,
  makeGetSelectedAssignee,
  makeGetSelectedTags,
} from '../../../../store/data/refinements/refinementsSelectors';
import {RefinedInboxParameters} from '../../../../store/panels/inboxes/parameters/inboxesParameters';
import {inboxParametersHasAssigneeLensCriteria} from '../../../../store/panels/inboxes/parameters/inboxesParametersHelpers';
import {CellsRefinementOptionsSearchDropdown} from './cellsRefinementOptionsSearchDropdown';

/*
 * Props.
 */

interface CellsRefinementOptionsSearchDropdownContainerProps {
  popoverProps: PopoverTransferProps;
  selectedRefinement: RefinementOptionModel | undefined;
  parameters: RefinedInboxParameters;
  company: CompanyModel;
  tagNamespaces: ReadonlyArray<string>;
  onSelectAssignee: HandlerOf<TeammateModel>;
  onSelectInbox: HandlerOf<InboxModel>;
  onSelectTag: HandlerOf<TagModel>;
}

/*
 * Selectors.
 */

function getParameters(_state: AppState, props: CellsRefinementOptionsSearchDropdownContainerProps) {
  return props.parameters;
}

function getCompany(_state: AppState, props: CellsRefinementOptionsSearchDropdownContainerProps) {
  return props.company;
}

function getTagNamespaces(_state: AppState, props: CellsRefinementOptionsSearchDropdownContainerProps) {
  return props.tagNamespaces;
}

function getSelectedRefinement(_state: AppState, props: CellsRefinementOptionsSearchDropdownContainerProps) {
  return props.selectedRefinement;
}

const makeGetHasAssigneeLensCriteria = () =>
  createSelector([getParameters, getLenses], (parameters, lenses) =>
    inboxParametersHasAssigneeLensCriteria(parameters, lenses),
  );

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CellsRefinementOptionsSearchDropdownContainerProps>()(() => ({
  parameters: getParameters,
  company: getCompany,
  tagNamespaces: getTagNamespaces,
  selectedTags: makeGetSelectedTags(getSelectedRefinement),
  selectedAssignee: makeGetSelectedAssignee(getSelectedRefinement),
  lensCriteria: makeGetLensCriteria(getParameters),
  hasAssigneeLensCriteria: makeGetHasAssigneeLensCriteria(),
  lensUpdatedAt: makeGetLensUpdatedAt(getParameters),
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({}));

export const CellsRefinementOptionsSearchDropdownContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CellsRefinementOptionsSearchDropdown);
